const ResetIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill='none' {...props}>
    <path
      fill='#14805C'
      d='M7.575 8.201h.25c.705 0 1.409-.005 2.113.002.608.007.95.444.833 1.048-.077.398-.382.632-.837.633-1.324.002-2.649 0-3.973 0h-.078c-.566-.003-.877-.311-.88-.888-.004-1.149 0-2.297 0-3.446 0-.236-.007-.472.001-.708.021-.597.471-.945 1.045-.815.371.084.605.385.609.805.005.57.001 1.141.001 1.712v.22c.167-.14.302-.258.443-.37 3.466-2.744 8.414-1.833 10.758 1.944 2.213 3.566 1.252 8.805-3.3 10.949-2.772 1.306-5.36.75-7.726-1.104-.576-.451-1.051-1.009-1.465-1.617-.227-.334-.23-.725-.017-1.01.215-.286.633-.443.951-.305.173.075.341.218.45.375.64.922 1.436 1.656 2.463 2.096 3.663 1.572 7.184-.58 8.027-4.117.665-2.79-.823-5.668-3.706-6.79-2.104-.82-4.426-.155-5.962 1.386Z'
    />
  </svg>
);
export default ResetIcon;
